import { tinymce } from '@vendor/libs/tinymce/tinymce';
const _TinymceComponentHandler = (function () {
    const locale = window.App.locale ?? 'pl';
    return {
        // Public functions
        init: function (selector) {
            tinymce.init({
                selector: '.tinymce',
                plugins: '',
                promotion: false,
                branding: false,
                verify_html: true,
                skin: false,
                content_css: false,
                language: locale,
                setup: function (editor) {
                    editor.on('change', function () {
                        tinymce.triggerSave();
                    });
                    editor.setContent($(selector).val());
                },
            });
        },
    };
})();
window.TinymceComponentHandler = _TinymceComponentHandler;
